import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: {
    tagList: {
      type: Array,
      default() {
        return [];
      }
    },
    tagData: {
      type: Array,
      default() {
        return [];
      }
    },
    format: {
      type: String,
      default: 'first'
    }
  },
  methods: {
    tagClose(index, index2, data) {
      let tagData = recursionCopy(this.tagData);
      tagData.map(item => {
        if (item.fieldKey == data.fieldKey) {
          item.children.map(item2 => {
            if (item2.fieldValue == data.fieldValue) {
              console.log(33);
              item2.choice = false;
            }
            return item2;
          });
          return item;
        }
      });
      this.tagList[index].splice(index2, 1);
      if (this.tagList[index].length == 0) {
        this.tagList.splice(index, 1);
      }
      let arr = [];
      let arr2 = [];
      this.tagList.map(item => {
        let obj = [];
        let obj2 = [];
        item.map(item2 => {
          obj.push(item2.sort);
          obj2.push({
            fieldName: item2.fieldName,
            fieldValue: item2.fieldValue
          });
        });
        arr.push(obj);
        arr2.push(obj2);
      });
      if (this.format == 'first') {
        this.$emit('ok', tagData, this.tagList, arr.join('-'));
      } else {
        this.$emit('ok', tagData, this.tagList, JSON.stringify(arr2));
      }
    }
  }
};